<template>
  <SearchFilters
    :expanded="expandFilter || isSearchFiltersExpanded || !isMobile"
    :selected-keyword="getInitialKeywordSearch"
    :selected-product-family="getInitialProductFamilySelected"
    :selected-subtopic="getInitialSubtopicSelected"
    :selected-product="getInitialProductSelected"
    :has-product-search-error="hasErrorFetchingProduct"
    @on-heading-cta="isSearchFiltersExpanded = $event"
    @on-search-filter-product-input="internalProductSearchError = false"
    @on-search-filter-product-cleared="onSearchFilterProductCleared"
    @on-search-filter-product-selected="onSearchFilterProductSelected"
    @on-search-filter-keyword-change="onSearchFilterKeywordChange"
    @on-search-filter-product-family-change="onSearchFilterProductFamilyChange"
    @on-search-filter-subtopic-change="onSearchFilterSubtopicChange"
    @on-search-filter-submit="onSearchFilterSubmit"
  />
</template>

<script src="./index.js"></script>

<style scoped lang="scss" src="./style.scss"></style>
